module.exports = __webpack_public_path__ + "static/media/archimedes_logo_blue_1024.6d9c7c62.png";